import { render, staticRenderFns } from "./RealName.vue?vue&type=template&id=1bbaa112&scoped=true&"
import script from "./RealName.vue?vue&type=script&lang=js&"
export * from "./RealName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbaa112",
  null
  
)

export default component.exports